import { Novu } from '@novu/js'

import { config } from '@/lib/helpers/config.helpers'

export let novuInstance: Novu

export const initializeNovu = (subscriberId: string, hash: string) => {
  novuInstance = new Novu({
    subscriberId,
    applicationIdentifier: config.novuAppIdentifier,
    apiUrl: config.novuApiUrl,
    socketUrl: config.novuSocketUrl,
    subscriberHash: hash,
  })

  return novuInstance
}
